/**
 * BasicInfoSection Component
 * 基礎資訊輸入區塊
 * Requirements: 2.1, 2.2, 2.3, 2.4, 2.5
 */

import type { CategoryType } from '../../types/card';
import type { Translations } from '../../i18n';

interface BasicInfoSectionProps {
  category: CategoryType;
  provider: string;
  productName: string;
  region: string;
  remarks: string;
  onProviderChange: (value: string) => void;
  onProductNameChange: (value: string) => void;
  onRegionChange: (value: string) => void;
  onRemarksChange: (value: string) => void;
  t: Translations;
}

export function BasicInfoSection({
  category,
  provider,
  productName,
  region,
  remarks,
  onProviderChange,
  onProductNameChange,
  onRegionChange,
  onRemarksChange,
  t,
}: BasicInfoSectionProps) {
  // 根據類型動態調整標籤
  const providerLabel = category === 'domain' ? t.registrar : t.provider;
  const productLabel = category === 'domain' ? t.domainName : t.productName;
  
  // 域名不需要地區欄位
  const showRegion = category !== 'domain';

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">{t.basicInfo}</h3>
      
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {providerLabel}
          </label>
          <input
            type="text"
            value={provider}
            onChange={(e) => onProviderChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder={providerLabel}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {productLabel}
          </label>
          <input
            type="text"
            value={productName}
            onChange={(e) => onProductNameChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder={productLabel}
          />
        </div>
      </div>

      {showRegion && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t.region}
          </label>
          <input
            type="text"
            value={region}
            onChange={(e) => onRegionChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder={t.region}
          />
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t.remarks}
        </label>
        <textarea
          value={remarks}
          onChange={(e) => onRemarksChange(e.target.value)}
          rows={2}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
          placeholder={t.remarks}
        />
      </div>
    </div>
  );
}
